import SettingsDrawer from './drawer';
//
import React from 'react';
import ThemeColorPresets from './ThemeColorPresets';
import ThemeContrast from './ThemeContrast';
import ThemeLocalization from './ThemeLocalization';
import ThemeRtlLayout from './ThemeRtlLayout';

// ----------------------------------------------------------------------

type ThemeSettingsProps = {
  children: React.ReactNode;
  withoutDrawer?: boolean;
};

export const ThemeSettings: React.FC<ThemeSettingsProps> = ({
  children,
  withoutDrawer,
}: ThemeSettingsProps) => {
  return (
    <ThemeColorPresets>
      <ThemeContrast>
        <ThemeLocalization>
          <ThemeRtlLayout>
            {children}
            {!withoutDrawer && <SettingsDrawer />}
          </ThemeRtlLayout>
        </ThemeLocalization>
      </ThemeContrast>
    </ThemeColorPresets>
  );
};

export default ThemeSettings;

export * from './type';
